module.exports = __webpack_public_path__ + "img/img3.925c8518.svg";